import React from "react";
import { Admin, Resource } from "react-admin";
import { authProvider, extendedDataProvider } from "./Utils";
import { createBrowserHistory as createHistory } from "history";
import customReducers from "./reducers";
import customSagas from "./sagas";
import myTheme from "./Utils/theme";
import MyLayout from "./Components/Layout/myLayout";
import { UserList } from "./Resource/User/userList";
import UserEdit from "./Resource/User/userEdit";
import UserShow from "./Resource/User/userShow";
import SignIn from "./Components/Pages/Authentication/LoginForm";
import MyLogoutButton from "./Components/Pages/Authentication/MyLogoutButton";
import customroutes from "./Components/customroutes";
import UserBadge from "./Resource/UserBadge";
import UserIcon from "@material-ui/icons/Group";
import Offers from "./Resource/Offers";
import Appointment from "./Resource/Appointment";
const history = createHistory();
const App = () => {
  return (
    <Admin
      theme={myTheme}
      logoutButton={MyLogoutButton}
      loginPage={SignIn}
      authProvider={authProvider}
      dataProvider={extendedDataProvider}
      customRoutes={customroutes}
      history={history}
      customReducers={customReducers}
      customSagas={customSagas}
      layout={MyLayout}
    >
      <Resource
        name="User"
        list={UserList}
        show={UserShow}
        edit={UserEdit}
        icon={UserIcon}
      />
      <Resource name="UserBadge" {...UserBadge} />
      <Resource name="Appointment" {...Appointment} />
      <Resource name="Offer" {...Offers} />
    </Admin>
  );
};

export default App;
